import { ProjectStatus } from './project-status.enum';

export enum FilterIds {
    Search = 'SEARCH',
    DateFrom = 'DATE_FROM',
    DateTo = 'DATE_TO'
}
